import { Navigate, createBrowserRouter } from "react-router-dom";
import Login from "./pages/Auth/login";
import Mainpage from "./pages/Main/mainpage";
import BusinessProfile from "./pages/Main/profile";
import RequestDetail from "./pages/Main/new-requests/manage-requests/RequestDetail";
import BusinessTypes from "./pages/Main/business-types";
import AddTypeCard from "./pages/Main/business-types/manage-types/AddTypeCard";
import Protected from "./components/protected";
import Categories from "./pages/Main/category/service";
import AdsApproval from "./pages/Main/ads";
import Orders from "./pages/Main/orders/allOrders";
import SupportTickets from "./pages/Main/support";
import Customers from "./pages/Main/customer";
import Personalsettings from "./pages/Main/customer/editCustomer";
import CategoryHome from "./pages/Main/category";
import SubCategory from "./pages/Main/category/subservice";
import Notifications from "./pages/Main/notifications";
import NewBusiness from "./pages/Main/new-business";
import BusinessDetail from "./pages/Main/new-business/business-detail";
import OrderDetails from "./pages/Main/orders/order-details";
import Dashboard from "./pages/Main/dashboard";
import PromoCode from "./pages/Main/promo-code";
import EditPromoCode from "./pages/Main/promo-code/editPromoCode";
import Prices from "./pages/Main/prices";
import FAQ from "./pages/Main/faq";
import TopDealsManager from "./pages/Main/top-deals";
import CartDiscountRulesManager from "./pages/Main/cart-discount-rules";
import PublicDealsModeration from "./pages/Main/public-deals";

const accessToken = localStorage.getItem("accessToken");
const router = createBrowserRouter([
  {
    path: "/",
    element: accessToken ? <Navigate to="/main/dashboard" /> : <Login />,
  },
  {
    path: "/login",
    element: <Login />,
  },

  {
    path: "login",
    element: <Login />,
  },

  {
    path: "main/*",
    element: <Protected Component={<Mainpage />} />,
    children: [
      {
        path: "profile",
        element: <BusinessProfile />,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "business-detail/:id",
        element: <RequestDetail />,
      },
      {
        path: "business-request-detail/:id",
        element: <BusinessDetail />,
      },
      {
        path: "business-types",
        element: <BusinessTypes />,
      },
      {
        path: "prices",
        element: <Prices />,
      },
      {
        path: "new-business",
        element: <NewBusiness />,
      },
      {
        path: "categories/*",
        element: <Protected Component={<CategoryHome />} />,
        children: [
          {
            path: "",
            element: <Categories />,
          },
          {
            path: "subservice",
            element: <SubCategory />,
          },
        ],
      },
      {
        path: "add-business-type",
        element: <AddTypeCard />,
      },

      {
        path: "ads",
        element: <AdsApproval />,
      },
      {
        path: "notifications",
        element: <Notifications />,
      },
      {
        path: "promo-code",
        element: <PromoCode />,
      },
      {
        path: "promo-code/:id",
        element: <EditPromoCode />,
      },
      {
        path: "orders",
        element: <Orders />,
      },
      {
        path: "order-details/:id",
        element: <OrderDetails />,
      },
      {
        path: "customers",
        element: <Customers />,
      },
      {
        path: "customers/:id",
        element: <Personalsettings />,
      },
      {
        path: "support",
        element: <SupportTickets />,
      },
      {
        path: "faq",
        element: <FAQ />,
      },
      {
        path: "top-deals",
        element: <TopDealsManager />,
      },
      {
        path: "cart-discount-rules",
        element: <CartDiscountRulesManager />,
      },
      {
        path: "public-deals",
        element: <PublicDealsModeration />,
      },
    ],
  },
]);

export default router;
